import moment from 'moment';


class StaticChannel {

  constructor(channelName, units) {
    this.channelName = channelName;
    this.units = units;
    this.data = [];
  }

  addData(newData) {
    if (!newData.length) {
      return;
    }
    if (typeof(newData[0].t) === typeof('')) {
      // Convert to `moment` objects.
      newData = newData.map(d => ({ t: moment.utc(d.t), y: d.y, }));
    }
    this.data = [...this.data, ...newData].sort((a, b) => a.t - b.t);
  }

  getId() {
    return this.channelName;
  }

  getUnits() {
    return this.units;
  }

  getData() {
    return this.data;
  }

  getStatus() {
    return 'Status';
  }

  clearData() {
    this.data = [];
  }
}

export default StaticChannel;


